import { request } from '../utils/request'

const baseUrl = 'https://se-main-gqi6flraoa-uc.a.run.app/main/';

export function getIframeData(token) {
    // console.log('Iframe: ', token)
    return request({
        method: 'get',
        url: baseUrl + `call/display`,
        headers: {},
        params: {
            token: token
        }
    })
}